import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import OutsideClickHandler from "react-outside-click-handler";
import MessageHelper from "../../../../entities/message/message-helper";
import { EventEmitter } from "../../../../shared/utils/event-emitter";
import Events from "../../../../const/events";
import { Tooltip } from "react-tooltip";
import "./thread-chat-modal.scss";

const PlatformIcon = ({ platform }) => {
  if (platform === "email") {
    return (
      <svg viewBox="0 0 32 32" width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2 11.9556C2 8.47078 2 6.7284 2.67818 5.39739C3.27473 4.22661 4.22661 3.27473 5.39739 2.67818C6.7284 2 8.47078 2 11.9556 2H20.0444C23.5292 2 25.2716 2 26.6026 2.67818C27.7734 3.27473 28.7253 4.22661 29.3218 5.39739C30 6.7284 30 8.47078 30 11.9556V20.0444C30 23.5292 30 25.2716 29.3218 26.6026C28.7253 27.7734 27.7734 28.7253 26.6026 29.3218C25.2716 30 23.5292 30 20.0444 30H11.9556C8.47078 30 6.7284 30 5.39739 29.3218C4.22661 28.7253 3.27473 27.7734 2.67818 26.6026C2 25.2716 2 23.5292 2 20.0444V11.9556Z" fill="white"></path> <path d="M22.0515 8.52295L16.0644 13.1954L9.94043 8.52295V8.52421L9.94783 8.53053V15.0732L15.9954 19.8466L22.0515 15.2575V8.52295Z" fill="#EA4335"></path> <path d="M23.6231 7.38639L22.0508 8.52292V15.2575L26.9983 11.459V9.17074C26.9983 9.17074 26.3978 5.90258 23.6231 7.38639Z" fill="#FBBC05"></path> <path d="M22.0508 15.2575V23.9924H25.8428C25.8428 23.9924 26.9219 23.8813 26.9995 22.6513V11.459L22.0508 15.2575Z" fill="#34A853"></path> <path d="M9.94811 24.0001V15.0732L9.94043 15.0669L9.94811 24.0001Z" fill="#C5221F"></path> <path d="M9.94014 8.52404L8.37646 7.39382C5.60179 5.91001 5 9.17692 5 9.17692V11.4651L9.94014 15.0667V8.52404Z" fill="#C5221F"></path> <path d="M9.94043 8.52441V15.0671L9.94811 15.0734V8.53073L9.94043 8.52441Z" fill="#C5221F"></path> <path d="M5 11.4668V22.6591C5.07646 23.8904 6.15673 24.0003 6.15673 24.0003H9.94877L9.94014 15.0671L5 11.4668Z" fill="#4285F4"></path> </g></svg>
    );
  }
  return (
    <svg viewBox="0 0 48 48" width="14" height="14" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Whatsapp-color</title> <desc>Created with Sketch.</desc> <defs> </defs> <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> <g id="Color-" transform="translate(-700.000000, -360.000000)" fill="#67C15E"> <path d="M723.993033,360 C710.762252,360 700,370.765287 700,383.999801 C700,389.248451 701.692661,394.116025 704.570026,398.066947 L701.579605,406.983798 L710.804449,404.035539 C714.598605,406.546975 719.126434,408 724.006967,408 C737.237748,408 748,397.234315 748,384.000199 C748,370.765685 737.237748,360.000398 724.006967,360.000398 L723.993033,360.000398 L723.993033,360 Z M717.29285,372.190836 C716.827488,371.07628 716.474784,371.034071 715.769774,371.005401 C715.529728,370.991464 715.262214,370.977527 714.96564,370.977527 C714.04845,370.977527 713.089462,371.245514 712.511043,371.838033 C711.806033,372.557577 710.056843,374.23638 710.056843,377.679202 C710.056843,381.122023 712.567571,384.451756 712.905944,384.917648 C713.258648,385.382743 717.800808,392.55031 724.853297,395.471492 C730.368379,397.757149 732.00491,397.545307 733.260074,397.27732 C735.093658,396.882308 737.393002,395.527239 737.971421,393.891043 C738.54984,392.25405 738.54984,390.857171 738.380255,390.560912 C738.211068,390.264652 737.745308,390.095816 737.040298,389.742615 C736.335288,389.389811 732.90737,387.696673 732.25849,387.470894 C731.623543,387.231179 731.017259,387.315995 730.537963,387.99333 C729.860819,388.938653 729.198006,389.89831 728.661785,390.476494 C728.238619,390.928051 727.547144,390.984595 726.969123,390.744481 C726.193254,390.420348 724.021298,389.657798 721.340985,387.273388 C719.267356,385.42535 717.856938,383.125756 717.448104,382.434484 C717.038871,381.729275 717.405907,381.319529 717.729948,380.938852 C718.082653,380.501232 718.421026,380.191036 718.77373,379.781688 C719.126434,379.372738 719.323884,379.160897 719.549599,378.681068 C719.789645,378.215575 719.62006,377.735746 719.450874,377.382942 C719.281687,377.030139 717.871269,373.587317 717.29285,372.190836 Z" id="Whatsapp"> </path> </g> </g> </g></svg>
  );
};

const ThreadChatModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const selectedThread = useSelector(
    (state) => state?.threadStore?.selectedThread || null
  );
  const isLoaderActive = useSelector(
    (state) => state?.messageStore?.isLoaderActive || false
  );
  const messages = useSelector((state) => state?.messageStore?.messages || []);
  const pagination = useSelector(
    (state) => state?.messageStore?.pagination || {}
  );

  const chatBodyRef = useRef(null);
  const modalRef = useRef(null);
  const isLoadingMoreRef = useRef(false);
  const topVisibleMessageIdRef = useRef(null); // Ref to store the ID of the top visible message
  const prevMessagesLengthRef = useRef(messages.length); // Ref to track previous message count

  // Determine if there are more messages to load
  const hasMoreMessages = pagination.page < pagination.totalPages;

  // Find the topmost visible message element
  const findTopVisibleMessageId = () => {
    if (!chatBodyRef.current) return null;
    const container = chatBodyRef.current;
    const containerScrollTop = container.scrollTop;
    const messageElements = container.querySelectorAll('.message-wrapper');

    // Since messages are reversed (newest first in DOM order, visually at bottom),
    // we iterate backwards through the DOM elements to find the first one
    // whose bottom edge is below or at the container's top scroll position.
    // This corresponds to the visually topmost message.
    for (let i = messageElements.length - 1; i >= 0; i--) {
      const element = messageElements[i];
      const elementTop = element.offsetTop;
      const elementBottom = elementTop + element.offsetHeight;

      // Check if the element is at least partially visible at the top
      if (elementBottom > containerScrollTop) {
        return element.id.replace('msg-', ''); // Return the message ID
      }
    }

    // Fallback: If no element meets the condition (e.g., scrolled way down),
    // anchor to the actual first message in the data array (visually topmost).
    if (messages.length > 0) {
        return messages[0]._id;
    }

    return null; // No visible message found
  };


  // Load older messages
  const loadOlderMessages = () => {
    if (hasMoreMessages && chatBodyRef.current && !isLoadingMoreRef.current) {
      isLoadingMoreRef.current = true;

      // Store the ID of the current top visible message before loading
      topVisibleMessageIdRef.current = findTopVisibleMessageId();
      console.log("Anchoring to message ID:", topVisibleMessageIdRef.current);

      // Load more messages
      MessageHelper.loadNextPage().finally(() => {
        isLoadingMoreRef.current = false;
      });
    }
  };

  // Effect to restore scroll position after loading older messages
  // Use useLayoutEffect to run synchronously after DOM updates but before paint
  useLayoutEffect(() => {
    if (topVisibleMessageIdRef.current && chatBodyRef.current) {
      const messageIdToFind = `msg-${topVisibleMessageIdRef.current}`;
      const messageElement = chatBodyRef.current.querySelector(`#${messageIdToFind}`);
      console.log("Trying to scroll to element:", messageElement);

      if (messageElement) {
        messageElement.scrollIntoView({ block: 'start', behavior: 'auto' });
        console.log("Scrolled to:", messageIdToFind);
        // Reset the ref after scrolling
        topVisibleMessageIdRef.current = null;
      } else {
         console.log("Anchor element not found:", messageIdToFind);
        // If element not found, clear the ref anyway
        topVisibleMessageIdRef.current = null;
      }
    }
    // Update previous message length after potential scroll adjustment
    prevMessagesLengthRef.current = messages.length;

  }, [messages]); // Trigger when messages array changes

  // Scroll to the bottom
  const _scrollToBottom = (force = false) => {
    // Only scroll to bottom if forced, or if not anchored
    if (chatBodyRef.current && (force || !topVisibleMessageIdRef.current)) {
       console.log(`Scrolling to bottom. Forced: ${force}, Anchor: ${topVisibleMessageIdRef.current}`);
      // Use timeout to allow potential layout updates after other effects
      setTimeout(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
      }, 0);
    }
  };

  // Register event listeners
  useEffect(() => {
    const _registerEvents = () => {
      EventEmitter.subscribe(Events.SHOW_THREAD_CHAT_MODAL, () => {
        setIsVisible(true);
        topVisibleMessageIdRef.current = null; // Reset anchor on open
        prevMessagesLengthRef.current = 0; // Reset message count on open
        // Allow time for modal to render and initial messages to load
        setTimeout(() => _scrollToBottom(true), 100); // Force scroll on open
      });
      EventEmitter.subscribe(Events.HIDE_THREAD_CHAT_MODAL, () => {
        setIsVisible(false);
      });
    };

    const _unregisterEvents = () => {
      EventEmitter.cancelAll(Events.SHOW_THREAD_CHAT_MODAL);
      EventEmitter.cancelAll(Events.HIDE_THREAD_CHAT_MODAL);
    };

    _registerEvents();
    return () => {
      _unregisterEvents();
    };
  }, []);

  // Effect to scroll down only for new messages (not when loading older ones)
  useEffect(() => {
    const isNewMessage = messages.length > prevMessagesLengthRef.current && !isLoadingMoreRef.current && !topVisibleMessageIdRef.current;
    console.log(`Checking for new message scroll: isVisible=${isVisible}, isNewMessage=${isNewMessage}, isLoading=${isLoadingMoreRef.current}, anchor=${topVisibleMessageIdRef.current}, prevLen=${prevMessagesLengthRef.current}, currLen=${messages.length}`);

    if (isVisible && isNewMessage) {
       // If modal is visible, we are not loading more, not anchored,
       // and the message count increased, assume it's a new message at the bottom.
      console.log("Detected new message, scrolling to bottom.");
      _scrollToBottom();
    }

    // Update prev length ref here as well, after the check
    // Although useLayoutEffect also does this, redundancy might be safer depending on effect order.
    prevMessagesLengthRef.current = messages.length;

  }, [messages, isVisible]); // Depend on messages and visibility

  // Format timestamp
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  // Format date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleDateString([], { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Check if dates are the same day
  const isSameDay = (date1, date2) => {
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return d1.getDate() === d2.getDate() && 
           d1.getMonth() === d2.getMonth() && 
           d1.getFullYear() === d2.getFullYear();
  };

  // Should show date separator
  const shouldShowDate = (message, previousMessage) => {
    if (!previousMessage) return true;
    return !isSameDay(message.createdAt, previousMessage.createdAt);
  };

  // Function to get initials from name
  const getInitials = (name) => {
    if (!name || typeof name !== 'string') return '?';
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  // Check if messages should be grouped
  const shouldGroupMessage = (currentMessage, previousMessage) => {
    if (!previousMessage) return false;
    
    return (
      previousMessage?.msgType === 'messages' && 
      currentMessage?.msgType === 'messages' && 
      previousMessage?._by?._id && 
      currentMessage?._by?._id && 
      (previousMessage?._by?._id === currentMessage?._by?._id)
    );
  };


  if (!isVisible || !selectedThread) {
    return null;
  }

  // Get contact names for header
  let modalTitle = "";
  if (selectedThread) {
    if (selectedThread.title?.length) {
      modalTitle = selectedThread.title;
    } else if (selectedThread._contacts?.length) {
      if ((selectedThread.type === "room" || selectedThread.type === "group") && selectedThread._contacts.length === 2) {
        modalTitle = `${selectedThread._contacts[0]?.name || 'Unknown'} & ${selectedThread._contacts[1]?.name || 'Unknown'}`;
      } else if (selectedThread.type === "group" && selectedThread._contacts.length > 2) {
        // For groups with more than 2 contacts, show first contact + count
        modalTitle = `${selectedThread._contacts[0]?.name || 'Unknown'} +${selectedThread._contacts.length - 1} others`;
      } else {
        modalTitle = selectedThread._contacts[0]?.name || selectedThread._contacts[0]?.phone || "Unknown Contact";
      }
    }
  }

  return (
    <div className="thread-chat-modal">
      <div className="modal-backdrop" onClick={() => EventEmitter.dispatch(Events.HIDE_THREAD_CHAT_MODAL)}></div>
      <OutsideClickHandler onOutsideClick={() => EventEmitter.dispatch(Events.HIDE_THREAD_CHAT_MODAL)}>
        <div className="modal-content" ref={modalRef}>
          {/* Modal Header */}
          <div className="modal-header">
            <h5 className="modal-title">Chat with {modalTitle}</h5>
            <button 
              type="button" 
              className="close-button"
              onClick={() => EventEmitter.dispatch(Events.HIDE_THREAD_CHAT_MODAL)}
            >
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          {/* Modal Body - Chat Messages */}
          <div className="modal-body">
            <div 
              className="chat-container" 
              id="scrollableChatDiv" 
              ref={chatBodyRef}
            >
              <InfiniteScroll
                dataLength={messages.length}
                next={loadOlderMessages}
                hasMore={hasMoreMessages}
                style={{
                  display: "flex",
                  flexDirection: "column-reverse",
                  overflow: "visible",
                }}
                scrollableTarget="scrollableChatDiv"
                inverse={true}
                loader={
                  <div className="loader-wrapper">
                    <img
                      src="assets/images/ring-loader.svg"
                      alt="loader"
                      className="loader"
                    />
                  </div>
                }
              >
                {messages.length === 0 ? (
                  <div className="no-messages">
                    <p>No messages in this conversation yet.</p>
                  </div>
                ) : (
                  messages.map((message, messageIndex) => {
                    const previousMessage = messages[messageIndex + 1];
                    const showDateSeparator = shouldShowDate(message, previousMessage);
                    const isGrouped = shouldGroupMessage(message, previousMessage);
                    
                    // Special handling for system messages
                    if (message.msgType !== "messages") {
                      const cleanBody = message.message
                        .replace(/\*Notification from [^*]+\*\s*/i, '')
                        .replace(/\s*sent to .+$/i, '')
                        .trim();
                      const recipientName = message._by?.name || 'Unknown';

                      return (
                        <React.Fragment key={message._id}>
                          <div id={`msg-${message._id}`} style={{ marginBottom: '8px', display: 'flex', justifyContent: 'center', padding: '0 16px' }}>
                            <div style={{
                              background: '#f8faff',
                              border: '1px solid #e0e7ff',
                              borderRadius: '8px',
                              padding: '7px 12px',
                              maxWidth: '480px',
                              width: '100%',
                            }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                <i className="mdi mdi-bell-outline" style={{ fontSize: '13px', color: '#4f46e5', flexShrink: 0 }}></i>
                                <div style={{
                                  display: 'inline-block',
                                  background: '#4f46e5',
                                  color: '#ffffff',
                                  fontSize: '10px',
                                  fontWeight: '700',
                                  padding: '1px 7px',
                                  borderRadius: '20px',
                                  letterSpacing: '0.3px',
                                  flexShrink: 0,
                                }}>
                                  SYSTEM
                                </div>
                                <div style={{ fontSize: '12px', color: '#374151', flex: 1, lineHeight: '1.4' }}>
                                  {cleanBody}
                                </div>
                              </div>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                fontSize: '11px',
                                color: '#9ca3af',
                                marginTop: '5px',
                                paddingTop: '5px',
                                borderTop: '1px solid #f3f4f6',
                              }}>
                                <p style={{ margin: 0 }}>→ {recipientName}</p>
                                <p style={{ margin: 0 }}>{formatTime(message.createdAt)}</p>
                              </div>
                            </div>
                          </div>
                          {showDateSeparator && (
                            <div className="date-separator">
                              <span>{formatDate(message.createdAt)}</span>
                            </div>
                          )}
                        </React.Fragment>
                      );
                    }
                    
                    // Regular messages
                    // Check if this is a group/room context - either by thread type or message.isGroup flag
                    const isGroupOrRoom = selectedThread.type === "room" || selectedThread.type === "group" || message.isGroup;
                    const isIncoming = isGroupOrRoom || message.direction === "incoming";
                    const senderName = message._by?.name || "Unknown";
                    
                    return (
                      <React.Fragment key={message._id}>
                        {/* <div
                          className={`message-wrapper ${isIncoming ? 'incoming' : 'outgoing'}`}
                          id={`msg-${message._id}`}
                        >
                          {isIncoming && !isGrouped && isGroupOrRoom && (
                            <div className="avatar">
                              <span>{getInitials(senderName)}</span>
                            </div>
                          )}
                          <div className="message">
                            {isGroupOrRoom && !isGrouped && (
                              <div className="sender-name">
                                {senderName}
                              </div>
                            )}
                            <div className={`message-content ${message?.metadata?.ai_filtered ? 'ai-flagged' : ''}`}>
                              {message.message}
                              {message?.metadata?.ai_filtered && (
                                <span className="ai-flag-indicator" data-tooltip-id="ai-flag-tooltip">
                                  <i className="fa fa-shield-alt"></i>
                                </span>
                              )}
                            </div>
                            <div className="message-time">
                              {formatTime(message.createdAt)}
                              {!isIncoming && (
                                <span className="status">
                                  {message.status === "read" ? (
                                    <span className="read" title="Read">
                                      <i className="fa fa-check-double"></i>
                                    </span>
                                  ) : (
                                    <span className="notRead" title="Delivered">
                                      <i className="fa fa-check"></i>
                                    </span>
                                  )}
                                </span>
                              )}
                            </div>
                          </div>
                        </div> */}


                        <div
                          className={`media message-wrapper ${isIncoming ? 'orange' : 'yellow'}`}
                          id={`msg-${message._id}`}
                        >
                          <div className="media-img">
                              {isIncoming && !isGrouped && isGroupOrRoom && (
                                <div className="avatar-box thumb-sm align-self-center"><span className="thumb-sm justify-content-center d-flex align-items-center bg-soft-primary rounded-circle">{getInitials(senderName)}</span></div>
                              )}
                              {isGroupOrRoom && !isGrouped && (
                                <div className="fullName d-flex align-items-center gap-2">
                                  <span>{senderName}</span>
                                  {message.byType === "Contact" && (
                                    <span className="platform-icon" title={message.platformOn === 'email' ? 'Email' : 'WhatsApp'}>
                                      <PlatformIcon platform={message.platformOn} />
                                    </span>
                                  )}
                                </div>
                              )}
                          </div>
                          <div className="media-body">
                              <div className={`chat-msg ${message?.metadata?.ai_filtered ? 'ai-flagged' : ''}`}>
                                <p>
                                  {message.message}
                                  {message?.metadata?.ai_filtered && (
                                    <span className="ai-flag-indicator" data-tooltip-id="ai-flag-tooltip">
                                      <i className="fa fa-shield-alt"></i>
                                    </span>
                                  )}
                                  <span className="timestamp">
                                    {formatTime(message.createdAt)}
                                    {!isIncoming && (
                                      <span className="status">
                                        {message.status === "read" ? (
                                          <span className="read" title="Read">
                                            <i className="fa fa-check-double"></i>
                                          </span>
                                        ) : (
                                          <span className="notRead" title="Delivered">
                                            <i className="fa fa-check"></i>
                                          </span>
                                        )}
                                      </span>
                                    )}
                                  </span>
                                </p>
                              </div>
                          </div>
                        </div>
                        {showDateSeparator && (
                          <div className="date-separator">
                            <span>{formatDate(message.createdAt)}</span>
                          </div>
                        )}
                      </React.Fragment>
                    );
                  })
                )}
              </InfiniteScroll>
              {/* Add tooltip for AI filtered messages */}
              <Tooltip id="ai-flag-tooltip" place="bottom">
                This message was filtered by AI and not forwarded as it violates organization policies
              </Tooltip>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default ThreadChatModal; 